<script>
	import { onMount } from 'svelte';
	export let url;
	import { link } from "svelte-routing";
	let article = false;
	if (typeof global === "undefined") {
	
		onMount(async () => {
			if (window.clientContext.articleViewPageContents && window.clientContext.articleViewPageContents.articleUrl == url) {
				article = window.clientContext.articleViewPageContents;
			}
			else fetch("/api/articles/get/"+url).then(r=>r.json()).then(r=>{
				article=r;
				document.title = article.meta.title;
				document.querySelector('meta[name="description"]').setAttribute("content", article.meta.desc);
			});
			console.log(window.clientContext.articleViewPageContents);
			
		});
		//products = Array(50).fill({loading: true});
		
	}
	else{
		article = global.ssrContext.articleViewPageContents;
	}
	
</script>

<div class="articlesHeader" >
	<a class="app_button-secondary" href="/articles" use:link>
		<svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M5.09025 12L14 2.66625L11.4549 0L0 12L11.4549 24L14 21.3338L5.09025 12Z" fill="white"/>
		</svg>
	</a>
	<div>
		<a href="/articles" use:link>Статьи</a>
		{#if article}<h2 >{article.head}</h2>{/if}
	</div>
</div>
{#if article}
<div class="articleBody" itemscope itemtype="https://schema.org/Article">
	<div>
		<div class="head">
			<h1 itemprop="name headline">{article.head}</h1>
			<span class="views">{article.views}</span>
		</div>
		<article itemprop="articleBody">{@html article.content.split("\n").join("<br>")}</article>
	</div>
	<div>
		<img itemscope itemprop="image url contentUrl" itemtype="http://schema.org/ImageObject" src={article.image}>
		<div class="info">
			<ul class="linkList">
				{#each article.links as li}
					<li><a href={li.link}>{li.name}</a></li>
				{/each}
			</ul>
			<ul class="tags">
				{#each article.tags as tag}
				<li>{tag}</li>
				{/each}
			</ul>
		</div>
	</div>
	<meta itemscope itemprop="mainEntityOfPage" itemType="https://schema.org/WebPage" itemid={"https://tradestore.su/topic/"+url} />

</div>

	{/if}

<style lang="scss">

	.articleBody{
		background: #0F131C;
		border: 1px solid #1A202D;
		border-radius: 14px;
		margin-top: 15px;
		padding: 30px;
		@media(max-width: 1440px){
			flex-direction: column;
		}
		display: flex;
		>div:nth-child(2){
			@media(max-width: 1440px){
				display: flex;
				gap: 40px;
				align-items: center;
				flex-wrap: wrap;
			}
			>img{max-width: 340px;}
			>div.info{
				>ul.tags{
					padding: 0; list-style: none; display: flex; gap: 10px; flex-wrap: wrap;
					>li{
						background: #1A202D;
						border-radius: 4px;
						font-style: normal;
						font-weight: 500;
						font-size: 16px;
						color: rgba(255,255,255,.5); padding: 5px;
					}
				}
				>ul.linkList{
					padding: 0; list-style: none;
					>li:not(:last-child){margin-bottom: 15px;}
					>li{
						&:hover{
							>a::before{
								background: #AF71DC url("data:image/svg+xml;base64,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") no-repeat center;

							}
						}
						
						cursor: pointer;
						>a::before{
							margin-right: 15px;
							transition: .1s linear;
							content: ' ';
							display: inline-flex;
							width: 50px; height: 50px;
							background: #1A202D url("data:image/svg+xml;base64,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") no-repeat center;
							border-radius: 4px;
						}
						>a{
							font-style: normal;
							font-weight: 500;
							font-size: 16px; color: #AF71DC;
							text-decoration: none;
							
							display: flex;
						align-items: center;
						}
					}
				}
			}
		}
		>div:first-child{
			flex-grow: 1;
			@media(min-width:1440px){
				border-right: 1px solid rgba(255,255,255,.1);
				margin-right: 20px;
				padding-right: 20px;
			}
			>div.head{
				display: flex;
				flex-grow: 1;
				width: 100%;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid rgba(255,255,255,.1);
				>span.views{
					color: #6B758B;
					display: flex;
					align-content: center;
					&::before{
						content: ' ';
						background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAyMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDAuMDM5MDYyNUM2LjE3ODc5IDAuMDM5MDYyNSAyLjcxMzUxIDIuMTI5NjggMC4xNTY0OSA1LjUyNTQxQy0wLjA1MjE2MzIgNS44MDM2MSAtMC4wNTIxNjMyIDYuMTkyMjggMC4xNTY0OSA2LjQ3MDQ4QzIuNzEzNTEgOS44NzAzIDYuMTc4NzkgMTEuOTYwOSAxMCAxMS45NjA5QzEzLjgyMTIgMTEuOTYwOSAxNy4yODY1IDkuODcwMjkgMTkuODQzNSA2LjQ3NDU3QzIwLjA1MjIgNi4xOTYzNyAyMC4wNTIyIDUuODA3NyAxOS44NDM1IDUuNTI5NUMxNy4yODY1IDIuMTI5NjggMTMuODIxMiAwLjAzOTA2MjUgMTAgMC4wMzkwNjI1Wk0xMC4yNzQxIDEwLjE5NzZDNy43Mzc1NSAxMC4zNTcyIDUuNjQyODQgOC4yNjY1MyA1LjgwMjM5IDUuNzI1ODhDNS45MzMzMSAzLjYzMTE3IDcuNjMxMTggMS45MzMzIDkuNzI1ODkgMS44MDIzOEMxMi4yNjI1IDEuNjQyODMgMTQuMzU3MiAzLjczMzQ1IDE0LjE5NzYgNi4yNzQxQzE0LjA2MjYgOC4zNjQ3MiAxMi4zNjQ3IDEwLjA2MjYgMTAuMjc0MSAxMC4xOTc2Wk0xMC4xNDczIDguMjU4MzVDOC43ODA4MSA4LjM0NDI2IDcuNjUxNjMgNy4yMTkxOCA3Ljc0MTY0IDUuODUyNzFDNy44MTExOSA0LjcyMzUyIDguNzI3NjMgMy44MTExOCA5Ljg1NjgxIDMuNzM3NTRDMTEuMjIzMyAzLjY1MTYyIDEyLjM1MjUgNC43NzY3MSAxMi4yNjI1IDYuMTQzMThDMTIuMTg4OCA3LjI3NjQ1IDExLjI3MjQgOC4xODg4IDEwLjE0NzMgOC4yNTgzNVoiIGZpbGw9IiM2Qjc1OEIiLz4KPC9zdmc+Cg==");
						width: 25px;
						height: 12px;
						display: inline-block;margin-top: 5px;
						background-repeat: no-repeat;
					}
				}
			}
		}
	}

	.articlesHeader{
		width: 100%;
		border-bottom: 1px solid rgba(255,255,255,.1);
		padding-bottom: 20px;
		display: flex;align-items: center;gap:10px;
		>.app_button-secondary{
			padding: 10px 15px; text-decoration: none;
		}
		>div{
			display: flex; align-items: center;
		}
		>div>a{
			font-style: normal;
			font-weight: 500;
			font-size: 16px;
			color: rgba(255, 255, 255, 0.5);
			text-decoration: none;
			&::after{
				content:"/";
				margin-right: 10px;
				margin-left: 2px;
			}
		}
		>div>h2{
			font-size: 24px;
			color: #9862C5;
			padding: 0px; margin: 0px;
		}
	}

</style>